import Web3 from 'web3'
import { contractabi } from '../contractdetails/contractdetails'
import { ethers } from 'ethers'

const networks = {
  astar: {
    endpoint: 'https://astar-rpc.dwellir.com',
    contractAddress: '0x2A314f5611BA26D947b346537AEB685f911fc26A'
  },
  moonbeam: {
    endpoint: 'https://moonbeam.public.blastapi.io',
    contractAddress: '0x2A314f5611BA26D947b346537AEB685f911fc26A'
  }
}

const web3Instances = {}
const contractInstances = {}

for (const network in networks) {
  const { endpoint, contractAddress } = networks[network]
  web3Instances[network] = new Web3(endpoint)
  contractInstances[network] = new web3Instances[network].eth.Contract(
    contractabi,
    contractAddress
  )
}

export const NETWORKS = {
  astar: 'astar',
  moonbeam: 'moonbeam'
}

export const getTotalMinted = async (network) => {
  const contractInstance = contractInstances[network]
  const totalMinted = await contractInstance.methods
    .totalSupply()
    .call({ gasLimit: 1000000 })
  return totalMinted
}

export const getMaxSupply = async (network) => {
  const contractInstance = contractInstances[network]
  const maxSupply = await contractInstance.methods
    .maxSupply()
    .call({ gasLimit: 1000000 })
  return maxSupply
}

export const isPausedState = async (network) => {
  const contractInstance = contractInstances[network]
  const paused = await contractInstance.methods
    .paused()
    .call({ gasLimit: 1000000 })
  return paused
}

export const isPublicSaleState = async (network) => {
  const contractInstance = contractInstances[network]
  const publicSale = await contractInstance.methods
    .allowPublicMint_()
    .call({ gasLimit: 1000000 })
  return !publicSale
}

let provider
if (typeof window !== 'undefined' && typeof window.ethereum !== 'undefined') {
  provider = new ethers.providers.Web3Provider(window.ethereum)
}

export const getPrice = async (network, rarityType) => {
  try {
    const contractInstance = contractInstances[network]
    const priceInWEI = await contractInstance.methods
      .getPrice(rarityType)
      .call({ gas: 1000000 })
    const priceInETH = web3Instances[network].utils.fromWei(priceInWEI, 'ether')
    return priceInETH
  } catch (error) {
    console.error('Error in getPrice: ', error)
  }
}

export const getRemainingTokens = async (network, rarityType) => {
  try {
    const contractInstance = contractInstances[network]
    const tokenIDRange = await contractInstance.methods
      .tokenIDRange_(rarityType)
      .call({ gas: 1000000 })
    const tokenIDCounter = await contractInstance.methods
      .tokenIDCounter_(rarityType)
      .call({ gas: 1000000 })

    if (parseInt(tokenIDCounter) >= parseInt(tokenIDRange.amount)) {
      return true
    } else {
      return false
    }
  } catch (e) {
    console.error('Error in Get Remaining', e)
  }
}
export const publicMint = async (
  network,
  mintAmount,
  connectedWallets,
  rarityType
) => {
  try {
    const contractInstance = contractInstances[network]

    const address = connectedWallets[0].accounts[0].address
    if (!address) {
      return {
        success: false,
        status: 'To be able to mint, you need to connect your wallet'
      }
    }
    const nonce = await provider.getTransactionCount(address, 'latest')
    const price = await getPrice(network, rarityType)
    const valueInWei = web3Instances[network].utils.toWei(
      (price * mintAmount).toFixed(18),
      'ether'
    )
    const valueInHex = web3Instances[network].utils.toHex(valueInWei)

    const tx = {
      to: networks[network].contractAddress,
      from: address,
      value: valueInHex, // hex
      data: contractInstance.methods
        .mintMultiple(mintAmount, rarityType)
        .encodeABI(),
      nonce: nonce.toString(16)
    }
    let txHash
    if (window?.ethereum) {
      txHash = await window.ethereum.request({
        method: 'eth_sendTransaction',
        params: [tx]
      })

      return {
        success: true,
        status: 'Transaction Successfull \n ' + txHash
      }
    } else {
      txHash = await web3Instances[network].eth.sendTransaction(tx)
      return {
        success: true,
        status: 'Transaction Successfull \n ' + txHash
      }
    }
  } catch (error) {
    console.error('Error in publicMint: ', error)
    return {
      success: false,
      status: 'Failed Transaction'
    }
  }
}

export const presaleMint = async (network, mintAmount, connectedWallets) => {
  const address = connectedWallets[0].accounts[0].address
  const contractInstance = contractInstances[network]
  console.log('connectedWallets', address)
  if (!address) {
    return {
      success: false,
      status: 'To be able to mint, you need to connect your wallet'
    }
  }

  const price = await getPrice(address)
  const nonce = await web3Instances[network].eth.getTransactionCount(
    address,
    'latest'
  )

  // Set up our Ethereum transaction
  const tx = {
    to: networks[network].contractAddress,
    from: address,
    value: parseInt(
      web3Instances[network].utils.toWei(String(price * mintAmount), 'ether')
    ).toString(16), // hex
    data: contractInstance.methods.presaleMint(mintAmount).encodeABI(),
    nonce: nonce.toString(16)
  }

  try {
    let txHash
    if (window?.ethereum) {
      txHash = await window.ethereum.request({
        method: 'eth_sendTransaction',
        params: [tx]
      })
    } else {
      await web3Instances[network].eth.sendTransaction(tx)
    }

    return {
      success: true,
      status: 'Transaction Successfull\n' + txHash
    }
  } catch (error) {
    return {
      success: false,
      status: '😞 Something went wrong:' + error.message
    }
  }
}
